import { MaterialIcons } from "@expo/vector-icons";
import { Platform } from "expo-modules-core";
import { StyleProp, StyleSheet } from "react-native";
import { useTheme } from "react-native-elements";
import RNPicker from "react-native-picker-select";

function DropDownIcon() {
  return <MaterialIcons name="arrow-drop-down" size={24} color={"#fff"} />;
}

export function Picker(props: {
  selectedValue: string;
  onValueChange: (itemValue: string, itemIndex: number) => void;
  data: { key: string; label: string; value: string }[];
  style?: StyleProp<any>;
}) {
  const { style, selectedValue, ...rest } = props;
  const theme = useTheme();
  return (
    <RNPicker
      {...rest}
      style={{
        inputAndroidContainer: {
          backgroundColor: theme.theme.colors.primary,
          padding: 8,
          paddingRight: 32,
          borderRadius: 4,
        },
        inputAndroid: StyleSheet.flatten([
          {
            color: "#fff",
          },
          style,
        ]),
        iconContainer: {
          top: 10,
          right: 4,
          width: Platform.OS === "web" ? 0 : 24,
          display: Platform.OS === "web" ? "none" : "flex",
        },
      }}
      placeholder={{}}
      fixAndroidTouchableBug={true}
      // @ts-expect-error Icon is not properly typed
      Icon={DropDownIcon}
      value={selectedValue}
      useNativeAndroidPickerStyle={false}
      dropdownIconColor={theme.theme.colors.black}
      dropdownIconRippleColor={theme.theme.colors.black}
      items={props.data}
    ></RNPicker>
  );
}
